import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./app/store";
import MainRouter from "./MainRouter";
import reportWebVitals from "./reportWebVitals";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import { GlobalStyles, ThemeHandler } from "mds";
import { createGlobalStyle } from "styled-components";

const MarkPro = require("./common/fonts/MarkPro.ttf");
const MarkProBold = require("./common/fonts/MarkPro-Bold.ttf");

const container = document.getElementById("root")!;
const root = createRoot(container);

const LocalStyles = createGlobalStyle`
    /* Fonts */
    @font-face {
        font-family: "Mark Pro";
        src: url(${MarkPro}) format("truetype");
        font-weight: normal;
        font-style: normal;
        font-display: swap;
    }

    @font-face {
        font-family: "Mark Pro";
        src: url(${MarkProBold}) format("truetype");
        font-weight: bold;
        font-style: normal;
        font-display: swap;
    }
    .graphiql-tooltip {
      background-color: #737373;
      color: #fff;
      padding: 8px;
      font-size: 12px;
      box-shadow: #00000050 0px 3px 10px;
      border-radius: 4px;
    }
`;

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeHandler>
        <GlobalStyles />
        <LocalStyles />
        <BrowserRouter>
          <MainRouter />
        </BrowserRouter>
      </ThemeHandler>
    </Provider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
